import reducer from "./reducer";
export { default as AssetsDiscountsMassiveEntry } from "./components/index";
export { default as assetsDiscountsMassiveEntryReducerName } from "./constants";
export default reducer;
